/**
 * Uniapp / in-app webview: only the intake form (no orders / submissions chrome).
 * Query: `embed=1` (also accepts truthy `true` / `yes`).
 */
export function isPublicRegisterEmbedQuery(
  query: Record<string, unknown> | { embed?: unknown } | undefined | null,
): boolean {
  if (!query || typeof query !== 'object') return false
  const raw = (query as { embed?: unknown }).embed
  const value = Array.isArray(raw) ? raw[0] : raw
  if (value === true || value === 1) return true
  const s = String(value ?? '')
    .trim()
    .toLowerCase()
  return s === '1' || s === 'true' || s === 'yes'
}
